













































import 'vue-awesome/icons/chart-line'
import 'vue-awesome/icons/caret-down'

export default
  name: 'account_forecast'
  props: ['account']
  data: ->
    modal_visible: false
    limit: 10
  components:
    balance: require('components/inside/elements/balance.vue').default
    transaction_amount: require('components/inside/pages/transactions/transaction_amount.vue').default
  computed:
    future_plans: ->
      trs = HM.store.state.user.transactions.filter((tr) => tr.isPlanned() && tr.isFuture() && tr.isUnconfirmed() && tr.isRelatedToAccount(@account.id))
      return trs if trs.length == 0
      trs = _.take _.orderBy(trs, 'date'), @limit
      future_balance = @account.balance
      trs = _.map trs, (tr) =>
        tr = _.clone tr
        if !tr.isTransfer()
          future_balance = future_balance + tr.plan_amount
        else if tr.transfer_to_id == @account.id # transfer to account
          future_balance = future_balance + tr.transfer_to_amount # don't use plan_amount, because currencies might be different
        else # transfer from account
          future_balance = future_balance - tr.plan_amount
        tr.future_balance = future_balance
        tr
  methods:
    openModal: ->
      @modal_visible = true
      @limit = 10
